import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-up",
  "use": "icon-arrow-up-usage",
  "viewBox": "0 0 9.8 6.1",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9.8 6.1\" id=\"icon-arrow-up\"><path d=\"M1.4 6.1L0 4.6 5 0l4.8 4.6-1.4 1.5L5 2.8 1.4 6.1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol